import { render, staticRenderFns } from "./HumanFilterEditValueCustomProduct.vue?vue&type=template&id=0b2ca967&scoped=true"
import script from "./HumanFilterEditValueCustomProduct.vue?vue&type=script&lang=ts"
export * from "./HumanFilterEditValueCustomProduct.vue?vue&type=script&lang=ts"
import style0 from "./HumanFilterEditValueCustomProduct.vue?vue&type=style&index=0&id=0b2ca967&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ca967",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2ca967')) {
      api.createRecord('0b2ca967', component.options)
    } else {
      api.reload('0b2ca967', component.options)
    }
    module.hot.accept("./HumanFilterEditValueCustomProduct.vue?vue&type=template&id=0b2ca967&scoped=true", function () {
      api.rerender('0b2ca967', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/models/HumanFilterEditValueCustomProduct.vue"
export default component.exports